import { render, staticRenderFns } from "./Mb2Svg.vue?vue&type=template&id=9adc3b3e&scoped=true"
import script from "./Mb2Svg.vue?vue&type=script&lang=js"
export * from "./Mb2Svg.vue?vue&type=script&lang=js"
import style0 from "./Mb2Svg.vue?vue&type=style&index=0&id=9adc3b3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9adc3b3e",
  null
  
)

export default component.exports